import React from "react";

/**
 * Root-level safety net. Bir bileşen render aşamasında hata atarsa
 * React tüm tree'yi unmount edip beyaz ekran gösterir (örn. `toast.error(obj)`).
 * Burada hatayı yakalayıp kullanıcıya anlamlı bir mesaj ve "Yeniden Yükle"
 * butonu sunuyoruz. Production'da finansal işlem ortamında sessizce
 * çökmek kabul edilemez.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", err, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, err: null });
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, err: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.err?.message || "Beklenmeyen bir hata oluştu.";
    return (
      <div
        data-testid="root-error-boundary"
        style={{
          minHeight: "100vh",
          background: "#0a0a0b",
          color: "#e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          fontFamily: "ui-sans-serif, system-ui, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 520,
            width: "100%",
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.02)",
            padding: 28,
          }}
        >
          <div
            style={{
              fontSize: 11,
              letterSpacing: "0.25em",
              textTransform: "uppercase",
              color: "#fb7185",
              marginBottom: 10,
            }}
          >
            Uygulama Hatası
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 12px" }}>
            Bir şeyler ters gitti
          </h2>
          <p style={{ color: "#9ca3af", fontSize: 13, lineHeight: 1.55 }}>
            Hata mesajı:{" "}
            <code
              style={{
                color: "#fda4af",
                background: "rgba(251,113,133,0.08)",
                padding: "2px 6px",
                borderRadius: 2,
                fontSize: 12,
              }}
            >
              {String(msg)}
            </code>
          </p>
          <p style={{ color: "#6b7280", fontSize: 12, marginTop: 14 }}>
            Veriler kaybolmadı. Sayfayı yeniden yükleyerek devam edebilirsin.
            Hatayı tekrarlanırsa konsolu açıp <b>[ErrorBoundary]</b> satırını
            paylaş.
          </p>
          <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
            <button
              type="button"
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              style={{
                background: "#fb923c",
                color: "#0a0a0b",
                border: 0,
                padding: "10px 16px",
                fontWeight: 600,
                fontSize: 12,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              Yeniden Yükle
            </button>
            <button
              type="button"
              onClick={this.handleReset}
              data-testid="error-boundary-reset"
              style={{
                background: "transparent",
                color: "#9ca3af",
                border: "1px solid rgba(255,255,255,0.1)",
                padding: "10px 16px",
                fontWeight: 500,
                fontSize: 12,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              Devam Et
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
